import { client } from '../client';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export const confirmOneReportMedia = async (media_id: string, userRole?: string): Promise<Response> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.patch<Response>(`${prefix}/media/${media_id}/confirm`, {});

  return data;
};
